import type { QueryClient } from '@tanstack/react-query'
import { createRouter } from '@tanstack/react-router'

import { routeTree } from './routeTree.gen'

/**
 * Router context, injected by `<RouterProvider context={{ queryClient }}>` in
 * App.tsx. Loaders read `({ context }) => context.queryClient.ensureQueryData(...)`.
 * The `undefined!` placeholder is never observed — RouterProvider always passes
 * the real client before anything renders.
 */
export interface RouterContext {
  queryClient: QueryClient
}

export const router = createRouter({
  routeTree,
  context: { queryClient: undefined! as QueryClient },
  defaultPreload: 'intent',
  // Also flips history.scrollRestoration to "manual", which stops iOS WKWebView
  // from restoring a scroll position of its own during swipe-back.
  scrollRestoration: true,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
